import { render } from "./SessionTagger.vue?vue&type=template&id=131d0b09&scoped=true"
import script from "./SessionTagger.vue?vue&type=script&lang=js"
export * from "./SessionTagger.vue?vue&type=script&lang=js"

import "./SessionTagger.vue?vue&type=style&index=0&id=131d0b09&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-131d0b09"]])

export default __exports__